import { render, staticRenderFns } from "./CircuitoNewversion.vue?vue&type=template&id=60e9f1a8&scoped=true"
import script from "./CircuitoNewversion.vue?vue&type=script&lang=js"
export * from "./CircuitoNewversion.vue?vue&type=script&lang=js"
import style0 from "./CircuitoNewversion.vue?vue&type=style&index=0&id=60e9f1a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e9f1a8",
  null
  
)

export default component.exports